module.exports = __webpack_public_path__ + "static/media/lightred2.20a33aa5.png";